<template>
  <div id="nav"></div>
  <router-view />
</template>

<style>
#app {
  width: 100%;
  height: 100%;
  outline: none;
  box-sizing: border-box;
}
</style>
